import { PortfolioTypes } from '~/models/PortfolioType';

// TODO: Move this to its own file
export const useHandlePortfolioDestinationChange = (setDestination: (destination: PortfolioTypes) => void) => {
    return async (portfolioType: PortfolioTypes) => {
        setDestination(portfolioType);
    };
};

interface PortfolioDestinationProps {
    destination: string;
    setDestination: (destination: PortfolioTypes) => void;
}

/** Radio buttons to select which portfolio to deposit into */
export const PortfolioDestination = ({ destination, setDestination }: PortfolioDestinationProps) => {
    const handlePortfolioDestinationChange = useHandlePortfolioDestinationChange(setDestination);
    const portfolios = [
        { id: PortfolioTypes.managed, title: 'Managed' },
        { id: PortfolioTypes.trading, title: 'Trading' }
    ];

    return (
        <div>
            <fieldset className={'mt-4 grid grid-cols-2 gap-x-5'}>
                {portfolios.map((portfolio) => (
                    <div
                        key={portfolio.id}
                        className={`space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10 p-3 rounded-md ${
                            radioBackground[portfolio.id]
                        }`}
                    >
                        <div className={`flex items-center`}>
                            <input
                                id={portfolio.id}
                                name={'notification-method'}
                                type={'radio'}
                                defaultChecked={portfolio.id === destination}
                                className={'focus:ring-green-600 h-4 w-4 text-green-600 border-gray-300'}
                                onChange={() => handlePortfolioDestinationChange(portfolio.id)}
                            />
                            <label htmlFor={portfolio.id} className={'ml-3 block text-gray-700'}>
                                {portfolio.title}
                            </label>
                        </div>
                    </div>
                ))}
            </fieldset>
        </div>
    );
};

const radioBackground: { [key: string]: string } = {
    managed: 'bg-turtleGreen-500 bg-opacity-10',
    trading: 'bg-blue-400 bg-opacity-20'
};
